/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import {
    Grid,
    Avatar,
    Box,
    Button,
    Dialog,
    Slide,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TextField,
    Typography,
    Divider,
} from "@mui/material";
import pr from "../lib/pr";
import get_token from "../lib/get_token";
import { useEffect, useState, forwardRef } from "react";
import axios from "axios";
import { loginState, configState } from "../lib/State";
import { useHistory, Link } from "react-router-dom";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import StaticDatePicker from "@mui/lab/StaticDatePicker";
import moment from "moment";
import PickersDay from "@mui/lab/PickersDay";
import { useSetRecoilState } from "recoil";
import Swal from "sweetalert2";
import RatingClass from './RatingClass';
import get_cid from '../lib/get_cid';
import get_center from '../lib/get_center';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const calTheme = createTheme({
    components: {
        MuiPickerStaticWrapper: {
            styleOverrides: {
                root: {
                    maxHeight: "320px",
                    height: "100%",
                },
            },
        },
    },
});

function MypageLoggedReservation(props) {
    const { login } = props;
    const [loaded, setLoaded] = useState(false);
    const history = useHistory();
    const [sdate, setSdate] = useState(moment().format("YYYY-MM-01"));
    const lastdate = new Date(moment(sdate).add(1, 'year').add(-1, 'day').format("YYYY-MM-DD"));
    const firstdate = new Date(moment(sdate).add(-1, 'year').add(-1, 'day').format("YYYY-MM-DD"));
    const minDate = new Date(moment().add(-1, "years"));
    const maxDate = new Date(moment().add(+1, "years"));
    const token = get_token();
    const [rows, setRows] = useState([]); // 예약현황
    const [next, setNext] = useState({
        class_time: "",
    });
    const [open, setOpen] = useState(false);
    const [coupon_seq, setCoupon_seq] = useState(0);
    const [classname, setClassname] = useState('');
    const [tname, setTname] = useState('');
    const [seq, setSeq] = useState(0);
    const [tcd, setTcd] = useState('');
    const cid = get_cid();
    const [drows, setDrows] = useState([]);

    const today = new Date(moment())

    const openClick = (params) => {
        let { seq, classname, tname, tcd, coupon_seq } = params;
        setSeq(seq);
        setClassname(classname);
        setTname(tname);
        setTcd(tcd);
        setCoupon_seq(coupon_seq);
        setOpen(true);
    }

    const closeClick = () => {
        setOpen(false);
        load_data();
    }

    // 예약 데이타    
    const load_data = async () => {
        let post_data = {
            token: token,
            mcd: login.mcd,
            cid: cid,
            level: login.level,
            sdate: sdate
        }
        let result = await axios.post(configState.api + "/gympass/my_reservation", post_data);
        if (result.data.success === 1) {
            setRows(result.data.rows);
            setDrows(result.data.drows);
        }
    }
    useEffect(() => {
        if (login.mcd !== "") {
            load_data();
        }

    }, [sdate])

    // 일정 가져오기 (달력 그리기)
    const renderWeekPickerDay = (date, selectedDates, pickersDayProps) => {
        let d = moment(date).format("D");
        let ym1 = moment(date).format("YYYY-MM-01");
        let ym2 = moment(sdate).format("YYYY-MM-01");

        // 같은달?
        // 지난달 다음달 숫자 빼기 위해서
        let this_month = false;
        if (ym1 === ym2) {
            this_month = true;
        }

        // 예약이 있나?
        let is_reserve = false;
        let idx = drows.findIndex((el) => moment(el.class_date).format('DD') === moment(date).format('DD'))
        if (idx > -1) {
            is_reserve = true;
        }

        return (
            <Box key={d} display="flex" alignItems="center" justifyContent="center"
                sx={{ width: 40, height: 36 }}
            >
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="cetner">
                    {this_month && is_reserve && drows[idx].pt_type === 'GX' && <Typography display="flex"
                        alignItems="center"
                        justifyContent="center" fontSize={15} sx={{ backgroundColor: "#0092a2", color: 'white', fontWeight: 'bold', width: 30, height: 30, borderRadius: "50%" }}>{d}
                    </Typography>}
                    {this_month && is_reserve && drows[idx].pt_type === 'PT_MANAGER' && <Typography display="flex"
                        alignItems="center"
                        justifyContent="center" fontSize={15} sx={{ backgroundColor: "#3a68de", color: 'white', fontWeight: 'bold', width: 30, height: 30, borderRadius: "50%" }}>{d}
                    </Typography>}
                    {this_month && is_reserve && drows[idx].pt_type === 'PT_TRAINER' && <Typography display="flex"
                        alignItems="center"
                        justifyContent="center" fontSize={15} sx={{ backgroundColor: "#dea23a", color: 'white', fontWeight: 'bold', width: 30, height: 30, borderRadius: "50%" }}>{d}
                    </Typography>}
                    {this_month && !is_reserve  && <Typography display="flex"
                        alignItems="center"
                        justifyContent="center" fontSize={15} sx={{ width: 30, height: 30, borderRadius: "50%" }}>{d}
                    </Typography>}
                    {!this_month && <Typography display="flex" alignItems="center" justifyContent="center" fontSize={15} sx={{ width: 30, height: 30, borderRadius: "50%" }}></Typography>}
                </Box>
            </Box>
        );
    }

    const onCancel = (params) => { // 예약취소
        const { seq, date, hour, classname, tname } = params;
        Swal.fire({
            html: `<div>${moment(date).format('YYYY년 MM월 DD일')} ${hour} ${moment(date).format('dddd')}</div>
            <div>${classname} - ${tname}</div>`,
            title: '예약을 취소하시겠습니까?',
            showConfirmButton: true,
            showCancelButton: true,
        })
            .then(async (result) => {
                if (result.isConfirmed) {
                    let result = await axios.post(configState.api + "/gympass/reservation_cancel", {
                        token: token,
                        mcd: login.mcd,
                        level: login.level,
                        cid: cid,
                        seq: seq,
                    });
                    if (result.data.success === 1) {
                        result = await axios.post(configState.api + '/push/to_mcd', {
                            cid: cid,
                            mcd: login.mcd,
                            title: '예약',
                            message: `${moment(date).format('M월 D일')} ${hour.slice(0, 2)}시 ${classname} 수업 예약이 취소되었습니다.`,
                        });
                        Swal.fire('취소 되었습니다.')
                            .then(() => {
                                load_data();
                            })
                            .catch(e => Swal.fire(e));
                    } else {
                        Swal.fire(result.data.msg);
                    }
                }
            })
            .catch((e) => Swal.fire(e));
    }

    const onCantCancel = () => {
        Swal.fire({
            title: '예약취소는 수업시작시간 1일 전까지 가능합니다.',
            showConfirmButton: true,
        })
    }
    return (
        <Grid
            container
            // display="block"
            width="100%"
            direction='column'
            justifyContent='center'
            alignItems='center'
            position='absolute'
            top='170px'
        // overflow='hidden'
        >
            <Dialog
                // fullScreen
                open={open}
                TransitionComponent={Transition}
                onClose={closeClick}
            >
                <Box
                    sx={{
                        width: '90%',
                        textAlign: 'left',
                        padding: '30px 0 10px 10px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start'
                    }}>
                    <img src='/img/back_button_black.png' onClick={closeClick} />
                    <Box
                        sx={{
                            margin: '16px 0 0 10px',
                            fontSize: '20px',
                            fontWeight: 'bold'
                        }}>
                        강사평가
                    </Box>
                </Box>
                <Divider />
                
                <RatingClass classname={classname} seq={seq} tcd={tcd} tname={tname} login={login} coupon_seq={coupon_seq} closeClick={closeClick} />
            </Dialog>
            {rows.length >= 0 &&
                <>
                    <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        locale={ko}
                    >
                        <ThemeProvider theme={calTheme}>
                            <StaticDatePicker
                                autoOk
                                views={["year", "month", "day"]}
                                minDate={minDate}
                                maxDate={maxDate}
                                displayStaticWrapperAs="desktop"
                                value={sdate}
                                onChange={(newValue) => { setSdate(moment(newValue).format("YYYY-MM-01")) }}
                                renderInput={(params) => <TextField {...params} />}
                                날짜에 badge로 표시하기
                                renderDay={renderWeekPickerDay}
                                onMonthChange={(newValue) => { setSdate(moment(newValue).format("YYYY-MM-01")) }}
                            ></StaticDatePicker>
                        </ThemeProvider>
                    </LocalizationProvider>
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'center',
                        }}>
                        <Box
                            sx={{
                                display: 'flex',
                                width: '80%',
                                justifyContent: 'flex-end',
                            }}>
                        {drows.filter((el) => el.pt_type === 'PT_MANAGER').length > 0 &&
                        <Box
                            sx={{
                                fontSize: '14px',
                                display: 'flex',
                                alignItems: 'center',
                                marginRight: '10px',
                            }}>
                            <Box
                                sx={{
                                    width: '12px',
                                    height: '12px',
                                    borderRadius: '50%',
                                    background: '#3a68de',
                                    marginRight: '3px',
                                }}></Box>
                            <Box>
                                점장
                            </Box>
                        </Box>
                        }
                        {drows.filter((el) => el.pt_type === 'PT_TRAINER').length > 0 &&
                        <Box
                            sx={{
                                fontSize: '14px',
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                            <Box
                                sx={{
                                    width: '12px',
                                    height: '12px',
                                    borderRadius: '50%',
                                    background: '#dea23a',
                                    marginRight: '3px',
                                }}></Box>
                            <Box>
                                트레이너
                            </Box>
                        </Box>
                        }
                        </Box>
                    </Box>
                </>
            }
            {
                rows.length === 0 &&
                <>
                    <Box
                        sx={{ minHeight: 80, textAlign: 'center', display: 'flex', alignItems: 'center' }}>
                        <Typography>
                            {moment(sdate).format('M')}월에는 예약이 없습니다.
                        </Typography>
                    </Box>

                    <Button
                        variant="contained"
                        component={Link}
                        to='/book'
                        sx={{
                            background: '#0092a2',
                            width: '320px',
                            marginTop: '10px'
                        }}>수업예약</Button>
                </>
            }

            {
                rows.length > 0 &&
                rows.map((item, index) => {

                    // 예약취소
                    let cancel_tf = false;
                    if (moment(item.class_date).format('YYYY-MM-DD') > moment().format('YYYY-MM-DD')) { // 당일취소 불가
                        cancel_tf = true;
                    }

                    return (
                        <Box
                            key={index}>
                            <Box
                                sx={{
                                    width: '320px',
                                    mb: 2,
                                    mt: 2,
                                    // background: '#f1f2f2',
                                    padding: '15px',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    background: '#f1f2f2'
                                }}>
                                <Box>
                                    <Box sx={{ fontWeight: "bold" }}>{item.pt_type === "PT_MANAGER" ? '점장 PT' : item.pt_type === 'PT_TRAINER' ? '트레이너 PT' : item.class_name}</Box>
                                    <Box fontSize='14px'>{item.tname} 강사</Box>
                                    <Box fontSize='14px'>{item.class_date} {item.class_hour}</Box>
                                </Box>
                                {(item.is_quit === 'N' || item.is_quit === 'null') && moment(item.class_date).format('YYYY-MM-DD') > moment().format('YYYY-MM-DD') ?
                                    <Box>
                                        <Button sx={{ color: 'black', border: 'black 1px solid' }} variant="outlined" onClick={() => onCancel({ seq: item.seq, date: item.class_date, hour: item.class_hour, classname: item.class_name, tname: item.tname })}>예약취소</Button>
                                    </Box>
                                
                                :(item.is_quit === 'Y' && item.point === 1 && item.res_seq !== item.seq && moment(item.class_date).add(7, 'd').format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD')) ?
                                    <Box>
                                        <Button sx={{ background: '#DE3A7B', color: 'white', ':hover': { background: '#DE3A7B', color: 'white' } }} onClick={() => openClick({ seq: item.seq, classname: item.class_name, tname: item.tname, tcd: item.tcd, coupon_seq: item.coupon_seq })}>강사평가</Button>
                                    </Box>
                                    :
                                    <Box>
                                        <Button sx={{ background: '#d4d5d5', color: '#a0a1a1', boxShadow: 'none', ':hover': { background: '#d4d5d5', color: '#a0a1a1', boxShadow: 'none' } }} variant="contained" onClick={() => onCantCancel()}>예약취소불가</Button>
                                    </Box>
                                }
                            </Box>

                        </Box>
                    )
                })}

            <Box sx={{ height: "100px" }}></Box>
        </Grid>
    )
}

export default MypageLoggedReservation;